import { FunctionComponent, useEffect, useState } from "react";
import { RouteBuilder } from "../constantes/routes.const";
import { useUserContext } from "../../user/contexts/user.context";
import i18n from "../../../i18n";

// Locales valides supportées par l'application
const VALID_LOCALES = ["en-US", "fr-FR"];
const DEFAULT_LOCALE = "en-US";

export const NotFoundRedirect: FunctionComponent = () => {
  const { hasUser, getUser, currentOrganization } = useUserContext();
  const [hasRedirected, setHasRedirected] = useState(false);

  // Workaround for https://github.com/ionic-team/ionic-framework/issues/23743
  // Route params are not properly bound by the ionic router after going through a redirect
  // This work by reloading the full app to the correct route instead of redirecting in the router.
  useEffect(() => {
    // Ne rediriger qu'une seule fois
    if (hasRedirected) {
      return;
    }

    // Attendre que l'utilisateur soit chargé (ou que l'authentification échoue)
    // Le RequireAuthGuard s'occupera de rediriger vers /login si nécessaire
    if (!hasUser) {
      return;
    }

    // Obtenir la locale (depuis i18next ou par défaut)
    let locale = i18n.language || DEFAULT_LOCALE;
    // Normaliser la locale
    if (locale === "fr") {
      locale = "fr-FR";
    } else if (locale === "en") {
      locale = "en-US";
    }
    if (!VALID_LOCALES.includes(locale)) {
      locale = DEFAULT_LOCALE;
    }

    // Obtenir le code organisation
    let orgCode: string | undefined;
    if (currentOrganization) {
      orgCode = currentOrganization.code;
    } else {
      try {
        const user = getUser();
        orgCode = user?.organizationList?.[0]?.code;
      } catch (e) {
        // L'utilisateur n'est pas encore chargé, ne rien faire
        return;
      }
    }

    // Construire l'URL de redirection
    if (orgCode) {
      setHasRedirected(true);
      window.location.href = RouteBuilder.home(locale, orgCode);
    }
  }, [hasUser, currentOrganization, getUser, hasRedirected]);
  
  return null;
};
